import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAlert } from "../../Provider/Alert/AlertContext";
import { getData } from "../../Services/apiService";

export function useGame({ idClient }) {
    const [games, setGames] = useState([]);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const { addAlert } = useAlert();

    const getGames = async () => {
        setLoading(true);
        try {
            const listGames = await getData(`/client/${idClient}/game`);

            
            if (listGames.status !== 200) {
                addAlert(
                    "danger",
                    t("financial.payment-values.modal.alert.list-game.title"),
                    t("financial.payment-values.modal.alert.list-game.message")
                );
                return;
            }
            
            console.log(listGames.body);
            setGames(listGames.body.data || []);
        } catch (error) {
            addAlert(
                "danger",
                t("financial.payment-values.modal.alert.error.title"),
                t("financial.payment-values.modal.alert.error.message")
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!idClient) return;

        getGames();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idClient]);

    return { games, loading };
}
